// types
import { createSlice } from "@reduxjs/toolkit";
import { percentageByEnum } from "../../data/common.data";

// initial state
const initialState = {
	isExpandedSideBar: false,
	isFacilityLoaded: false,
	isFilterDateUpdate: true,
	isManualFacilityChange: false,
	lastADTDate: null,
	isCensusDataLoading: false,
	selectedAccount: null,
	projectionDays: null,
	customPercentage: null,
	customPercentageLabel: null,
	percentageBy: percentageByEnum.censusAverage,
	customePercentages: [],
	isScrollHightLight: null,
	endDateOfADT: null,
	isProjectionPopup: false,
	isNotePopup: false,
	isNoteExpanded: false,
	selectedShortcutOptions: {
		isCompare: false,
		isAutoReport: false,
		isAlertsReport: false,
		isPickProjectionDays: false,
		isNotes: false,
		isPageConverter: false,
	},
	isCustomTabAdded: false,
	headerFilterItems: null,
	isLayoutMode: false,
	isFacilityLoading: false,
	pauseDate: null,
	hasShownPauseDialog: false,
	showMultipleFacilitiesPauseDialog: false,
	pauseDialogShownForFacilities: null,
	pauseUser: null,
	isLoginLoading: false,
	skipMainFetch: false,
	enableComparisonFetch: false,
};

// ==============================|| SLICE - common ||============================== //

const common = createSlice({
	name: "common",
	initialState,
	reducers: {
		setIsExpandedSideBar(state, action) {
			state.isExpandedSideBar = action.payload;
		},
		setIsCustomTabAdded(state, action) {
			state.isCustomTabAdded = action.payload;
		},
		setIsNoteExpanded(state, action) {
			state.isNoteExpanded = !state.isNoteExpanded;
		},
		setIsOpenNote(state, action) {
			state.isNotePopup = action.payload;
		},			
		setSelectedShortcutOptions(state, action) {
			state.selectedShortcutOptions = action.payload;
		},
		setIsProjectionsPopup(state, action) {
			state.isProjectionPopup = action.payload;
		},
		setEndDateOfADT(state, action) {
			state.endDateOfADT = action.payload;
		},
		setIsScrollHightLight(state, action) {
			state.isScrollHightLight = action.payload;
		},
		setCustomePercentages(state, action) {
			state.customePercentages = action.payload;
		},
		setFacilityLoaded(state, action) {
			state.isFacilityLoaded = action.payload;
		},
		setLastADTDate(state, action) {
			state.lastADTDate = action.payload;
		},
		setFilterDateUpdate(state, action) {
			state.isFilterDateUpdate = action.payload;
		},
		setIsManualFacilityChange(state, action) {
			state.isManualFacilityChange = action.payload;
		},
		setCensusDataLoading(state, action) {
			state.isCensusDataLoading = action.payload;
		},
		setProjectionDays(state, action) {
			state.projectionDays = action.payload;
		},
		setSelectedAccount(state, action) {
			state.selectedAccount = action.payload;
		},
		setCustomPercentage(state, action) {
			state.customPercentage = action.payload;
		},
		setCustomPercentageLabel(state, action) {
			state.customPercentageLabel = action.payload;
		},
		setPercentageBy(state, action) {
			state.percentageBy = action.payload;
		},
		setHeaderFilterItems(state, action) {
			state.headerFilterItems = action.payload;
		},
		setIsLayoutMode(state, action) {
			state.isLayoutMode = action.payload;
		},
		setIsFacilityLoading(state, action) {
			state.isFacilityLoading = action.payload;
		},
		setPauseDateSlice(state, action) {
			state.pauseDate = action.payload;
		},
		setHasShownPauseDialog(state, action) {
			state.hasShownPauseDialog = action.payload;
		},
		setShowMultipleFacilitiesPauseDialog(state, action) {
			state.showMultipleFacilitiesPauseDialog = action.payload;
		},
		resetPauseDialogFlags(state) {
			state.hasShownPauseDialog = false;
			state.showMultipleFacilitiesPauseDialog = false;
			state.pauseDialogShownForFacilities = null;
		},
		setPauseDialogShownForFacilities(state, action) {
			state.pauseDialogShownForFacilities = action.payload;
		},
		setPauseUser(state, action) {
			state.pauseUser = action.payload;
		},
		setIsLoginLoading(state, action) {
			state.isLoginLoading = action.payload;
		},
		setSkipMainFetch(state, action) {
			state.skipMainFetch = action.payload;
		},
		setEnableComparisonFetch(state, action) {
			state.enableComparisonFetch = action.payload;
		},
	},
});

export default common.reducer;

export const {	
	setCustomPercentageLabel,
	setPercentageBy,
	setPercentageAgainst,
	setCustomPercentage,
	setCensusDataLoading,
	setProjectionDays,
	setLastADTDate,
	setFilterDateUpdate,
	setIsManualFacilityChange,
	setFacilityLoaded,
	setSelectedAccount,
	setCustomePercentages,
	setIsScrollHightLight,
	setEndDateOfADT,
	setIsProjectionsPopup,
	setSelectedShortcutOptions,
	setIsOpenNote,	
	setIsNoteExpanded,
	setIsExpandedSideBar,
	setIsCustomTabAdded,
	setHeaderFilterItems,
	setIsLayoutMode,
	setIsFacilityLoading,
	setPauseDateSlice,
	setHasShownPauseDialog,
	setShowMultipleFacilitiesPauseDialog,
	resetPauseDialogFlags,
	setPauseDialogShownForFacilities,
	setPauseUser,
	setIsLoginLoading,
	setSkipMainFetch,
	setEnableComparisonFetch
} = common.actions;
